import { useState, useEffect } from "react";
import "./ExploreBrand.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import { useBrands } from "../../contexts/BrandContext";
import Breadcrums from "../../components/breadcrums_v2/Breadcrums";
import FallbackImg from "../../components/FallbackImg";
import ApiService from "../../components/Api_services";

const ExploreBrand = () => {
  const [search, setSearch] = useState("");
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  // const { brands, loading } = useBrands();

  useEffect(() => {
    setLoading(true);
    ApiService.getAllBrand().then((res) => {
      if (res.status === 200) setBrands(res.data.brand);
      setLoading(false);
    });
  }, []);

  const filteredBrands = brands.filter((b) =>
    b.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="explorebrand_v2">
      <Breadcrums />
      <div className="explorebrand-content_v2">
        <div className="explorebrand-title-container_v2">
          <div className="explorebrand-title_v2">
            <div>BRANDS</div>
            <div className="searchbar-explorebrand_v2">
              <input
                type="text"
                placeholder="Search brand"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div
                className="searchbar-explorebrand-remove_v2"
                style={{
                  visibility: search ? "visible" : "hidden",
                  pointerEvents: search ? "auto" : "none",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setSearch("");
                }}
              >
                &#x2715;
              </div>
              <Search color={"#717182"} size={16} style={{ width: "40px" }} />
            </div>
          </div>
        </div>

        <div className="explorebrand-main_v2">
          {loading ? (
            <div style={{ textAlign: "center", margin: "40px 0" }}>
              Loading...
            </div>
          ) : brands.length > 0 ? (
            <div className="explorebrand-item-container_v2">
              {filteredBrands.map((brand) => (
                <div className="explorebrand-item-inner_v2">
                  <Link
                    key={brand.id}
                    to={`/productlist?brands=${brand.id}`}
                    className="explorebrand-item_v2"
                  >
                    <FallbackImg
                      src={brand.photo_url}
                      alt={brand.name}
                      style={{
                        width: "150px",
                        height: "80px",
                        objectFit: "contain",
                        borderRadius: "10px",
                        padding: "20px",
                      }}
                      loading="lazy"
                    />
                  </Link>
                  <span>{brand.name}</span>
                </div>
              ))}
            </div>
          ) : (
            <div>No brand available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExploreBrand;
